import { constructEnum } from '@/lib/enum';

const SocialMediaType = constructEnum('SocialMediaType', {
  NONE: 0,
  UNKNOWN: 5,
  FACEBOOK: 10,
  INSTAGRAM: 20,
  NAVER_CAFE: 30,
  NAVER_BLOG: 40,
  YOUTUBE: 100,
  VIMEO: 110
});

SocialMediaType.svgName = type => {
  const mediaType = SocialMediaType.toKey(type).toLowerCase();
  if (mediaType.startsWith('naver')) return 'naver-shaded';
  return `${mediaType}-shaded`;
};

export default SocialMediaType;
